// ** React Imports
import { Fragment, useState, useEffect } from "react";
import {Link, useParams,useNavigate, useLocation } from "react-router-dom";

// ** MUI Imports
import {
  Avatar,
  AvatarGroup,
  IconButton,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Menu,
  MenuItem,
  FormLabel,
  FormControl,
  FormControlLabel,
  Grid,
  Divider,
  Checkbox,
  ToggleButton,
  ToggleButtonGroup,
  InputAdornment,
  CircularProgress,
  Backdrop,
  Popover,
  Radio,
  RadioGroup,
} from "@mui/material";
import MuiStep from "@mui/material/Step";
import { styled, useTheme } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import MuiTimeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DataGrid } from "@mui/x-data-grid";
import { DataGridPro } from '@mui/x-data-grid-pro';

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import _ from 'lodash';

// ** Util Imports
import { hexToRGBA } from "../../components/utils/hex-to-rgba";

// ** Custom Component Imports
import CustomTextField from "../../components/mui/text-field";
import CustomChip from "../../components/mui/chip";

// ** Component Imports
import DateRangeCalendar from "../Customers/component/DateRangeCalendar";
import WorkRequirements from "../Assessments/component/WorkRequirements";
import AddServiceDialog from "../Assessments/component/AddService";
import AddBundleDialog from "screens/Assessments/component/AddBundle";

// ** Icon Imports
import Icon from "../../components/icon";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AddIcon from "@mui/icons-material/Add";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CloseIcon from "@mui/icons-material/Close";

// ** Custom Components Imports
import CustomAvatar from "../../components/mui/avatar";
import CustomAutocomplete from "components/mui/autocomplete";
import OptionsMenu from "../../components/option-menu";

// ** Third Party Components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

// ** Layout Import
import UserLayout from "../../components/layouts/UserLayout";

// ** Logic Imports
import { useIndexLogic } from "screens/Customers/logic/indexLogic";
import { useCustomerLogic } from "screens/Customers/logic/CustomerLogic";
import { useUnsavedChanges } from "components/UnsavedChangesContext";
import { useCreateEstimateLogic } from "./logic/create-estimate-logic";
import { GetJobsite } from "screens/Customers/logic/GetJobsites";
import { GetServiceRequestRaw } from "screens/Requests/logic/GetServiceRequest";
import { getTermsNConditions } from "screens/Settings/logic/TermsNConditionsLogic";
import AddContactDialog from "screens/Customers/component/AddContact";
import TagManagementDialog from "screens/Customers/component/TagManagement";
import LinkedRecordsComponent from "screens/Requests/component/LinkedRecordsComponent";
import NotesComponent from "screens/Requests/component/NotesComponent";
import AssignToComponent from "screens/Assessments/component/AssignToComponent";
import ConversionComponent from "screens/Requests/component/ConversionComponent";
import { getStatusRules, STATUS_ORDER, STATUS_RULES, canTransition} from "./logic/StatusManager";
import PreAttachment from "screens/Requests/component/PreAttachment";
import { useWorkRequirementLogic } from "screens/WorkOrders/logic/work-requirement-logic";
import { useAssignToLogic } from "screens/Assessments/logic/AssignToLogic";
import { SendEstimate } from "./logic/SendEstimate";
import UnsavedChangesDialog from "components/UnsavedChangesDialog";
import { SaveCommunicationLog } from "screens/Customers/logic/SaveCommunicationLog";
import AttachmentsComponent from "screens/Requests/component/AttachmentsComponent";
import { GetContacts } from "screens/Customers/logic/GetContacts";
import { SendNotification } from "components/SendNotification";
import AddJobsiteDialog from "screens/Customers/component/AddJobsite";
import { GetEntityLinks, DeleteLinkRecord } from "screens/Requests/logic/LinkRecordLogic";
//#region Constants

// Styled Timeline component
const Timeline = styled(MuiTimeline)({
  "& .MuiTimelineItem-root": {
    width: "100%",
    "&:before": {
      display: "none",
    },
  },
});

// ** Styled Components
const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : theme.palette.common.white,
    minWidth: 220,
    maxWidth: 440,
    border: "1px solid #E1E4EA",
  },
}));


const dropdownItemsStyle = {
  px: 6,
  py: 2,
  "&:hover": {
    backgroundColor: "action.hover",
    cursor: "pointer",
  },
};

// Custom Styled Button
const PopoverButton = ({}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Button
        variant="contained"
        color="main"
        endIcon={<KeyboardArrowDownIcon />}
        aria-describedby={id}
        onClick={handleClick}
      >
        Convert To
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ py: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography variant="h6" sx={dropdownItemsStyle}>
              Work Order
            </Typography>
          </Box>
        </Box>
      </Popover>
    </div>
  );
};

const Customersteps = [
  {
    icon: "tabler:user",
    title: "Profile Information",
  },
  {
    icon: "tabler:address-book",
    title: "Add Contact",
  },
  {
    icon: "tabler:align-box-bottom-center",
    title: "Add Jobsite",
  },
];


const parseAvailabilityDays = (daysString) => {
  try {
    const daysArray = JSON.parse(daysString);
    // Ensure that only numbers are kept in the array
    return daysArray.filter((item) => typeof item === 'number');
  } catch (error) {
    //console.error('Error parsing availabilityDays:', error);
    return [];
  }
};

 
//#endregion Contants 
   const MainOptions = ({rules, sendEstimate}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <IconButton 
        onClick={handleClick}
        sx={{ 
          width: '40px', 
          height: '40px',
          flexShrink: 0
        }}
      >
        <Icon icon='tabler:dots-vertical' />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          '& .MuiPopover-paper': {
            minWidth: '200px', // Fixed width to prevent jiggle
            transform: 'translateZ(0)' // Hardware acceleration
          }
        }}
      >
        <Box sx={{ py: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* <Typography 
              variant="h6" 
              sx={{
                ...dropdownItemsStyle,
                minHeight: '40px', // Fixed height
                display: 'flex',
                alignItems: 'center'
              }}
            >
              Close Estimate
            </Typography> */}
            <Typography 
              variant="h6" 
              sx={{
                ...dropdownItemsStyle,
                minHeight: '40px', // Fixed height
                display: 'flex',
                alignItems: 'center'
              }}
              onClick={() => {
                if(rules.canEdit) {
                  sendEstimate();
                } else {
                  toast.error("You cannot send estimate at this stage.", {
                    position: "top-right",
                      theme: "light",
                      style: {
                        fontFamily: '"DM Sans", sans-serif',
                        fontSize: '15px',
                      },
                  });
                }
                handleClose(); // Close immediately after click
              }}
            >
              Send to Customer
            </Typography>
            {/* <Typography 
              variant="h6" 
              sx={{
                ...dropdownItemsStyle,
                minHeight: '40px', // Fixed height
                display: 'flex',
                alignItems: 'center'
              }}
            >
              Preview
            </Typography> */}
          </Box>
        </Box>
      </Popover>
    </div>
  );
};
const CustomChipWithDropdown = ({ tag, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();

  const isUnclickable = tag === "Work Order";

  const handleClick = (event) => {
    if (isUnclickable) return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (selectedTag) => {
    onSelect(selectedTag);
    handleClose();
  };

  const statusColors = {
    "Needs Revision": "info",
    "Under Review": "info",
    "Approved": "success",
    "Completed": "success",
    "Work Order": "success",
    "Submitted": "success",
    "On Hold": "warning",
    "Awaiting Approval": "warning",
    "Awaiting Deposit": "warning",
    "Rejected": "error",
    "Closed": "error",
  };
  
  const statuses = [
    "Under Review",
    "Needs Revision",
    "Awaiting Approval",
    "Awaiting Deposit",
    "Approved",
    "On Hold",
    "Completed",
    "Rejected",
  ];
  
  return (
    <Box>
      <CustomChip
        borderRadius="4px"
        size="small"
        skin="light"
        onClick={handleClick}
        color={statusColors[tag] || "secondary"}
        sx={{
          lineHeight: 1,
          py: 1,
          ...(isUnclickable && {
            pointerEvents: "none", 
            cursor: "default",
            "&:hover": {
              backgroundColor: "inherit !important",
              boxShadow: "none !important",
            },
            opacity: 1,
          }),
        }}
        label={
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <FiberManualRecordIcon fontSize="small" />
            <Typography variant="caption" sx={{ fontSize: "0.8rem" }}>
              Status:
            </Typography>
            <Typography variant="caption" sx={{ fontSize: "0.8rem", fontWeight: 660 }}>
              {tag}
            </Typography>
          </Box>
        }
      />
      
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableAutoFocusItem   
        disableRestoreFocus
        PaperProps={{ sx: { width: 200 } }}
      >
        {statuses.map((status) => {
          const isSelected = tag === status;

          return (
            <MenuItem
              key={status}
              selected={isSelected}
              onClick={() => handleSelect(status)}
              sx={{
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                },
                "&.Mui-selected": {
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.common.white,
                  "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                  },
                },
              }}
            >
              {status}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};

const EstimateDetail = () => {
  // ** Hooks and Vars
  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const theme = useTheme();

  const { requestID } = useParams();

  //#region States

  const contentHeightFixed = false;
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("1");
  const [openSearchRecordsDlg, setOpenSearchRecordsDlg] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [openScheduleAst, setOpenScheduleAst] = useState(false);
  const [schedulingReq, setSchedulingReq] = useState(false);
  const [openUploadDlg, setOpenUploadDlg] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(new Date());
  const [notesSort, setNotesSort] = useState(true);
  // const [openServiceDlg, setOpenServiceDlg] = useState(false);
  // const [isServiceEmpty, setIsServiceEmpty] = useState(true);
  const [openComLog, setOpenComLog] = useState(false);
  const [estTravelTime, setEstTravelTime] = useState(false);
  const [billingFreq, setBillingFreq] = useState("select");
  const [recurringType, setRecurringType] = useState("weekly");
  const [depositReq, setDepositReq] = useState(false);
  const [depositType, setDepositType] = useState("percentage");
  const [formatsBilling, setFormatsBilling] = useState([]);    
  const [monthlyOptions, setMonthlyOptions] = useState('billingDay');
  const [openSpecialInstr, setOpenSpecialInstr] = useState(false);
  const [oldServiceRequest, setOldServiceRequest] = useState({});
  const [tabValue, setTabValue] = useState("1");
  const [openUploadDlg2, setOpenUploadDlg2] = useState(false);
  const [conversionBannerVisible, setConversionBannerVisible] = useState(false);
   const [linkedFromEntityId, setLinkedFromEntityId] = useState(null);
const [undoClicked, setUndoClicked] = useState(false);

  const [isChanged, setIsChanged] = useState(false);
  const { setHasUnsavedChanges, hasUnsavedChanges } = useUnsavedChanges();
   const [openUnsavedChangesDlg, setOpenUnsavedChangesDlg] = useState(false);
   const [unsavedDialogAction, setUnsavedDialogAction] = useState({
      action: '',
      tabValue: '',
    });
   const [termsAndConditions, setTermsAndConditions] = useState([]);
     const handleOpenUnsavedChangesDlg = (action, tabValue) => {
      if(action === 'tabChange'){
        setUnsavedDialogAction({
          action: action,
          tabValue: tabValue,
        });
      }else{
        setUnsavedDialogAction({
          action: action,
          tabValue: '',
        });
      }
      setOpenUnsavedChangesDlg(true); 
    }
    const handleCloseUnsavedChangesDlg = () => setOpenUnsavedChangesDlg(false);
    const handleDiscardChanges = () => { 
      if(unsavedDialogAction.action === 'tabChange'){
        setOpenUnsavedChangesDlg(false); 
        setTabValue(unsavedDialogAction.tabValue)
      } else if(unsavedDialogAction.action === 'upload'){
        setOpenUnsavedChangesDlg(false); 
          // setFiles([]);
          // setUploadFiles([]);
          setOpenUploadDlg2(false); 
      } else{
        setOpenUnsavedChangesDlg(false); 
        navigate('/estimates')
      }
    }
  

  const [btnLoading, setButtonLoading] = useState(false);
  const location = useLocation();

  const [status, setStatus] = useState('');
      const [rules, setRules] = useState(
        { 
          canEdit: true,
          canDelete: true,
          canSubmit: true,
          nextStatuses: [],
          cannotGoBack: false
        });

    const [flagList, setFlagList] = useState({
      isCustomerLoaded:false, 
      isJobsiteLoaded:false, 
      isContactsLoaded:false, 
      isPrefferedTimeLoaded:false,
      isPreferedDaysLoaded:false,
      isCompleteWorkByLoaded:false, 
      isTagsLoaded:false,
      isViewed:false
    });


    
    const sendEstimate = async () => {
      try{
        setLoading(true);
        const result = await SendEstimate(serviceRequest?.requestID , 0, navigate);
        if (result) {
          toast.success("Estimate Email sent successfully.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
              theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
          const contacts = (await GetContacts(serviceRequest?.customerID)) ?? [];
          const primaryContact = contacts.find(c => c.primary === true || c.isPrimary === true);
          const contactID = primaryContact?.id ?? 0;
          const communication = {
            communicationLogID: 0,
            customerID: serviceRequest?.customerID,
            contactID: contactID,
            type: "Email",
            description: "An Estimate was sent via an Email",
            entityID: serviceRequest?.requestID,
            entityType: "Estimate",
            communicationLogTime: dayjs(new Date).format("YYYY-MM-DDTHH:mm:ss"),  
            followUpReminderTime: dayjs(new Date()).add(7, 'day').format("YYYY-MM-DDTHH:mm:ss"),      
          }

          const communicationResponse = SaveCommunicationLog(communication);

          // console.log(communicationResponse)


        } else {
          toast.error("Estimate Email sending failed.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
              theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
      }catch(error){
        console.error("Error sending estimate:", error);
      }finally{
        setLoading(false);
        fetchRequests(requestID, false);
      }
    }



  //start
  
  const [openNewCustomerDlg, setOpenNewCustomerDlg] = useState(false);
  const {IndexProps} = useIndexLogic();
  const {fetchData, allCustomers} = IndexProps;

  const {CustomerProps} = useCustomerLogic({activeStep, setActiveStep,Customersteps,setOpenNewCustomerDlg, fetchData, allCustomers});

  const {setCustomer, customer, allJobsites, setAllJobsites,setIsCompleted, isCompleted, fetchContacts, contacts,
    jobsite,
    setJobsite,
    openNewJobsiteDlg,
    setOpenNewJobsiteDlg,
    handleOpenNewJobsiteDlg,
    handleCloseNewJobsiteDlg,
    handleJobsiteChange,
    handleOpenTagManagementDlg,
    //handleDeleteTag,
    handleOpenNewCustomerDlg,
    openTagManagementDlg,
    handleCloseTagManagementDlg,
    fetchJobsites
  } = CustomerProps;

  const stepsRequestDetails = [
    {
      serial: "1",
      title: "Basic Information",
      icon: "tabler:list-details",
    },
    {
      serial: "2",
      title: "Work Requirements",
      icon: "tabler:align-box-left-stretch",
    },
    {
      serial: "3",
      title: "Billing Information",
      icon: "tabler:align-box-left-stretch",
    },
    {
      serial: "4",
      title: "Link Records",
      icon: "tabler:link",
    },
    {
      serial: "5",
      title: "Notes",
      icon: "tabler:ballpen",
    },
    {
      serial: "6",
      title: "Assign To",
      icon: "tabler:user-share",
    },
  ];

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { CreateEstimateProps } = useCreateEstimateLogic({handleClose,activeStep,setActiveStep,stepsRequestDetails,setLoading});

  const {
    isBundleEmpty,
    //handleOpenBundleDlg,
    openAddBundle,
    handleCloseBundleDlg,
    isServiceEmpty,
    //handleOpenServiceDlg,
    openServiceDlg,
    handleCloseServiceDlg,
    handleSave,
    handleFormat,
    handleEstimateNext,
    handleBack,
    formats,
    ddlArray,
    allContacts,
    openNewContactDlg,
    handleCloseContactDialog,
    toast,                     
    handleAddTag,
    handleDeleteTag,
    // handleCloseNewJobsiteDlg,
    //  openNewJobsiteDlg,
    // setOpenNewJobsiteDlg,
    propertyArea,
    areaMeasurement,
    activeStepJobsite,
    jobsiteContent,
    clearPropertyArea,
    clearAreaMeasurement,
    setActiveStepJobsite,
    setPropertyArea,
    setAreaMeasurement,
    setAlertList,
    // handleJobsiteChange,
    alertList,
    files,
    setFiles,
    NProgress,
    // fetchJobsites,
    propertyAreaList,
    serviceRequest,
    setServiceRequest,
    Tag,
    setTag,
    resetRequest,
    handleCustomerDropdownChange,
    requestErrors,
    handleJobsiteDropdownChange,
    handleContactDropdownChange,
    handleCompleteWorkByDateChange,
    SaveService,
    validateRequestField,
    // handleOpenNewJobsiteDlg,
    handleOpenNewContactDlg,
    //handleTimeChange, 
    fetchPropertyArea,
    setRequestErrors,   
  } = CreateEstimateProps;
   

   const [initialServiceRequest, setInitialServiceRequest] = useState(serviceRequest);
  const {  
    AssignToProps
  } = useAssignToLogic({serviceRequest, setLoading, requestID, requestType: "Estimate",navigate});

  const {    
    filteredEmployees,       
    assignedUserIds,     
  } = AssignToProps;


  // Work Requirememt section
    
      const {
        AddServiceProps,
        AddBundleProps,
        WorkRequirementsProps,
        AttachmentProps
      } = useWorkRequirementLogic({requestID, navigate,toast, setLoading,serviceRequest, entity: 'estimate-detail'});
  
      const {
        handleOpenBundleDlg,
        handleOpenServiceDlg,
        workRequirementList,    
      } = WorkRequirementsProps;
    
      /////end of work Requirement


  const availabilityDaysArray = parseAvailabilityDays(serviceRequest.availabilityDays || "[]");

  useEffect(() => {  
      if(requestID){
        fetchRequests(requestID, true);
      }      
  }, [requestID]);

  useEffect(() => {
    if (serviceRequest?.requestID > 0) {
      setRules(getStatusRules(serviceRequest?.status));
      setStatus(serviceRequest?.status);
    }
  }, [serviceRequest?.requestID]);

  // Fetch Terms & Conditions when the tab is opened
  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      if (value !== "7") return; // Only fetch when T&C tab is active
      
      try {
        setLoading(true);
        const terms = await getTermsNConditions(navigate, 0, "Estimate");
        
        // Filter to only show Estimate module terms
        const estimateTerms = terms.filter(t => t.moduleName === "Estimate");
        
        // Transform data to match grid format
        const transformedTerms = estimateTerms.map((item) => ({
          id: item.termID,
          termID: item.termID,
          description: item.terms,
          moduleName: item.moduleName || "",
          createdOn: item.createDate ? dayjs(item.createDate).format("YYYY-MM-DD") : "",
          createdBy: item.createdBy || "",
          lastUpdated: item.modifiedDate ? dayjs(item.modifiedDate).format("YYYY-MM-DD") : (item.createDate ? dayjs(item.createDate).format("YYYY-MM-DD") : ""),
        }));
        
        setTermsAndConditions(transformedTerms);
      } catch (error) {
        console.error("Error fetching terms and conditions:", error);
        toast.error("Failed to fetch Terms & Conditions", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
      } finally {
        setLoading(false);
      }
    };
    fetchTermsAndConditions();
  }, [value]);

  useEffect(() => {
    // Check if we arrived from a conversion page using the flag in localStorage
    const conversionFlag = localStorage.getItem('fromConversion');

    if (conversionFlag === 'true') {
      // setIsFromConversion(true);
      setValue("6");
      
      // Optional: Clear the flag after checking (or leave it for future visits)
      localStorage.removeItem('fromConversion');
    }
  }, [location]); // Runs on location change

  useEffect(() => {
    if (flagList.isViewed && serviceRequest?.isViewed) {

      const SaveStatus = async () => {
        const result = await SaveService();

        if (result) {
          fetchRequests(requestID, false);
          setStatus(serviceRequest.status);
          setRules(getStatusRules(serviceRequest?.status));
          toast.success("Status changed to " + serviceRequest?.status, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        } else {
          toast.error("Status update failed.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
      }

      SaveStatus();

      //fetchRequests(requestID);
      setFlagList((prev) => ({
        ...prev, "isViewed": false
      }));
    }
  }, [flagList.isViewed]);

  const handleIsViewed = () => {
    if (!serviceRequest?.isViewed && (serviceRequest?.status === ('Submitted' || 'Not Viewed'))) {
      setServiceRequest((prevState) => ({
        ...prevState,
        status: 'Under Review',
        isViewed: true
      }));
      setFlagList((prev) => ({
        ...prev, "isViewed": true
      }));
      setStatus('Under Review');
    }
  };

 const showConfirmationStatus = (key, value) => {
  MySwal.fire({
    title: <strong>Are you sure you want to approve?</strong>,
    html: <span>The Customer has not Accepted this Estimate yet. Have you spoken to them and received approval?</span>,
    showCancelButton: true,
    confirmButtonText: "Yes, approve!",
    cancelButtonText: "Not yet!",
     allowEscapeKey: true,
       width: '46px', // Explicit width control
  padding: '1rem',
    focusConfirm: false,
     showCloseButton: true,
     closeButtonHtml: '&times;', // This is the × symbol
    customClass: {
     popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
         cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
    }
  }).then(async (result) => {
    if (result.isConfirmed) {
      setServiceRequest((prevState) => ({
        ...prevState,
        [key]: value,
      }));
      
      try {
        setLoading(true);
        const result = await SaveService();
        if (result) {
          setStatus(value);
          setRules(getStatusRules(value));
          toast.success(`Status changed to ${value}`, {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
            style: {
              fontFamily: '"DM Sans", sans-serif',
              fontSize: '15px',
            },
          });
        }
      } catch (error) {
        console.error("Error updating status:", error);
      } finally {
        setLoading(false);
      }
    }
  });
}

 const handleStatusChange = async (key, value) => {
  if (canTransition(status, value)) {
    if(value === 'Approved'){
      showConfirmationStatus(key, value);
    } else {
      setServiceRequest((prevState) => ({
        ...prevState,
        [key]: value,
      }));
      try {
        setLoading(true);
        const result = await SaveService();
        if (result) {
          setStatus(value);
          setRules(getStatusRules(value));
          toast.success(`Status changed to ${value}`, {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
            style: {
              fontFamily: '"DM Sans", sans-serif',
              fontSize: '15px',
            },
          });
        } else {
          setServiceRequest((prevState) => ({
            ...prevState,
            [key]: status,
          }));
          toast.error("Status update failed.", {
            position: "top-right",
            theme: "light",
            style: {
              fontFamily: '"DM Sans", sans-serif',
              fontSize: '15px',
            },
          });
        }
      } catch (error) {
        console.error("Error updating status:", error);
        setServiceRequest((prevState) => ({
          ...prevState,
          [key]: status,
        }));
      } finally {
        setLoading(false);
      }
    }      
  } else {
    toast.error(`You cannot move from ${status} to ${value}.`, {
      position: "top-right",
      theme: "light",
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
  }
}

  const formatCurrencyDisplay = (value) => {
    if (value === '' || value === null || value === undefined) return '';
    const num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
    return isNaN(num) ? '' : num.toLocaleString();
  };

  const handleServiceRequestChange = (field, value) => {
    if (field === 'depositAmount') {
      const numericValue = value.replace(/[^0-9.]/g, '');
      
      if (numericValue === '' || !isNaN(numericValue)) {
        setServiceRequest(prev => ({ ...prev, [field]: Number(numericValue) }));
      }
    } else {
      setServiceRequest(prev => ({ ...prev, [field]: value }));
    }
  };
  
    useEffect(()=>{
      if(flagList.isCustomerLoaded && flagList.isJobsiteLoaded, flagList.isContactsLoaded){ 
        const timer = setTimeout(() => {        
          setLoading(false); 
          handleIsViewed();
        }, 1000);
        return () => clearTimeout(timer);                
      }
    },[flagList.isCustomerLoaded && flagList.isJobsiteLoaded, flagList.isContactsLoaded])
  
    useEffect(() => {    
      fetchJobsites2(serviceRequest?.customerID); 
    }, [serviceRequest?.customerID]);

     useEffect(() => {
        const isEqual = _.isEqual(oldServiceRequest, serviceRequest); // Deep compare OldEmp and employee
        setIsChanged(!isEqual); 
        setHasUnsavedChanges(!isEqual);
      }, [oldServiceRequest, serviceRequest]);
  
    const fetchJobsites2 = async (customerID) => {
      if(customerID) {
        try {
          let jobs = await GetJobsite(customerID, 0, navigate);  
          setAllJobsites(jobs);
  
        } catch (error) {
          console.error("Error fetching Jobsite data:", error);
        }
      }
    };
  
    useEffect(() => {
      if (serviceRequest?.customerID) {      
        fetchContacts(serviceRequest?.customerID);
        setFlagList((prev)=>({
          ...prev, "isContactsLoaded":true
        })); 
      }    
    }, [serviceRequest?.customerID]);
  
    useEffect(()=>{
      if(serviceRequest?.jobSiteID  || serviceRequest?.jobSiteID){
        // console.log('Fetching propertyarea of jobsiteID : ', serviceRequest?.jobSiteID)
        setJobsite(allJobsites.filter(x => x.jobsiteID === serviceRequest?.jobSiteID)[0]);
        fetchPropertyArea(serviceRequest?.jobSiteID);
        setFlagList((prev)=>({
          ...prev, "isJobsiteLoaded":true
        })); 
      }
    },[allJobsites]);
  
    useEffect(()=> {
      setCustomer(allCustomers.filter(x => x.customerID === serviceRequest?.customerID)[0]); 
      setIsCompleted(true);  
      //fetchWorkRequirements(requestID);     
      setFlagList((prev)=>({
        ...prev, "isCustomerLoaded":true
      }));     
    },[allCustomers,serviceRequest?.customerID])
  
    const fetchRequests = async (RequestID = requestID) => {
      try {
        setLoading(true);
        let RequestRaw = await GetServiceRequestRaw(0, RequestID);
        const newRequest = RequestRaw.result[0];
        
        setServiceRequest(newRequest);
        setOldServiceRequest(newRequest); // Always update the old state
        setStatus(newRequest.status);
        
        // Only update initial state if not undoing
        if (!undoClicked) {
          setInitialServiceRequest(newRequest);
        }
      } catch (error) {
        console.error("Error fetching Requests data:", error);
        toast.error("Failed to fetch request data.", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
      } finally {
        setLoading(false);
      }
    };
    
    useEffect(() => {
      if (requestID) {
        fetchLinks();
      }
    }, [requestID]);
  
    const fetchLinks = async () => {
      setLoading(true);
      try {
        const linkedEntities = await GetEntityLinks(requestID);      
        if (linkedEntities && linkedEntities.length > 0) {
          const linkedEntity = linkedEntities.find((entity => entity.toEntityId
   || entity.toEntityId
   == requestID));
          if (linkedEntity) {
            setLinkedFromEntityId(linkedEntity.fromEntityId);
          }}
      } catch(error){
        console.log(error);
      } finally {
        setLoading(false);
      }
    } 
  const validateBasicFields = () => {
      const tempErrors = {};

      if (!serviceRequest.requestTitle) 
        tempErrors.requestTitle = 'Request Title is required';

      if (serviceRequest.isDeposit && !serviceRequest.depositAmount)
        tempErrors.depositAmount = 'Deposit Amount must be greater than 0';

      if (!serviceRequest.customerID) 
          tempErrors.customerID = 'Customer is required';
  
      if (!serviceRequest.jobSiteID || !allJobsites?.some((jobsite) => jobsite.jobsiteID === serviceRequest?.jobSiteID)) 
          tempErrors.jobSiteID = 'Jobsite is required';
  
      if (!serviceRequest.jobsiteContactID || !contacts?.some((contact) => contact.id === serviceRequest?.jobsiteContactID)) 
          tempErrors.jobsiteContactID = 'Jobsite Contact is required';
  
  
      setRequestErrors(tempErrors);
  
      return Object.keys(tempErrors).length === 0;
  };

  const handleInitialData = () => {
    const initialData = initialServiceRequest;
    setServiceRequest(initialData);
  }

  // const handleUndo = async () => {
  //   setUndoClicked(true);
  //   handleInitialData();
  //   handleSaveServiceRequest();
  // }
  
  const handleUndo = async () => {
    const newValue = oldServiceRequest;
    setServiceRequest(newValue);

    const result = await SaveService(newValue);
    if(!result.isError){
      fetchRequests();
    }
  };

  const handleSaveServiceRequest = async () => {
    
    if (!validateBasicFields()) {
      return;
    }
    
    setButtonLoading(true);
    try {
      const result = await SaveService();
      
      if (result) {
        SendNotification(navigate);
        await fetchRequests(requestID, true);
        setStatus(serviceRequest.status);
        setRules(getStatusRules(serviceRequest?.status));
        
        if (!undoClicked) {
          toast.success(
            ({}) => (
              <Box
                           display="flex"
                           alignItems="center"
                           justifyContent="space-between"
                         >
                           <Typography sx={{ flex: 1 }}>
                             Estimate updated successfully.
                           </Typography>
                           <Button
                             variant="contained"
                             color="main"
                             size="small"
                             sx={{
                               mr: 4,
                               borderRadius: "20px", 
                               minWidth: "64px", 
                             }}
                             onClick={(e) => {
                               e.preventDefault();
                               handleUndo();
                             }}
                           >
                             Undo
                           </Button>
                         </Box>
            ),
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          );
        }
      } else {
        toast.error("Estimate update failed.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      }
    } catch (e) {
      console.error(e);
      toast.error("An error occurred while updating the estimate.", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
    } finally {
      setButtonLoading(false);
    }
  };

  const handleTimeChange = (timeValue, isSelected) => {
    try {
      const timeKey = Number(Object.keys(timeMapping).find((key) => timeMapping[key] === timeValue));
      let updatedTimes = JSON.parse(serviceRequest.availabilityTime || "[]");
  
      if (isSelected) {
        if (timeKey === 1) {
          // If "Anytime" is selected, replace all times with [1, 2, 3, 4]
          updatedTimes = [1, 2, 3, 4];
        } else {
          // Add the specific time
          updatedTimes = [...new Set([...updatedTimes, timeKey])];
          // Remove "Anytime" if another time is selected
          updatedTimes = updatedTimes.filter((t) => t !== 1);
  
          // Automatically check "Anytime" if all 2, 3, 4 are selected
          if (updatedTimes.includes(2) && updatedTimes.includes(3) && updatedTimes.includes(4)) {
            updatedTimes = [1, 2, 3, 4];
          }
        }
      } else {
        // Remove the time from the list
        updatedTimes = updatedTimes.filter((t) => t !== timeKey);
  
        // If "Anytime" is being deselected, clear all times
        if (timeKey === 1) {
          updatedTimes = [];
        } else {
          // Uncheck "Anytime" if any specific time is deselected
          updatedTimes = updatedTimes.filter((t) => t !== 1);
        }
      }
  
      // Update the serviceRequest state
      setServiceRequest((prevState) => ({
        ...prevState,
        availabilityTime: JSON.stringify(updatedTimes),
      }));
        
    } catch (e) {
      console.log("Error in handleTimeChange:", e);
    }
  };
  const handleDayChange = (day) => {
    // Parse the availabilityDays string into an actual array of numbers
    let updatedDays = serviceRequest.availabilityDays
      ? parseAvailabilityDays(serviceRequest.availabilityDays)
      : [];

    // Get the numeric value of the selected day (e.g., "Mon" -> 1)
    const dayNumber = dayToNumberMap[day];

    // Toggle the day in the list
    if (updatedDays.includes(dayNumber)) {
      // If the day is already selected, remove it
      updatedDays = updatedDays.filter((d) => d !== dayNumber);
    } else {
      // If the day is not selected, add it
      updatedDays.push(dayNumber);
    }

    // Update the serviceRequest state, storing only numbers
    setServiceRequest((prevState) => ({
      ...prevState,
      availabilityDays: JSON.stringify(updatedDays), // Store as a clean stringified array of numbers
    }));
  };

  const dayToNumberMap = {
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
    Sun: 0,
  };

  const daysMapping = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const timeMapping = {
    1: "Anytime",
    2: "Morning",
    3: "Afternoon",
    4: "Evening",
  };

  const allDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const allTimes = ["Anytime", "Morning", "Afternoon", "Evening"];

  useEffect(() => {
    if (Object.keys(requestErrors).length > 0) {
      const timer = setTimeout(() => {
        setRequestErrors([]);
      }, 5000);
      return () => clearTimeout(timer);
    }
    }, [requestErrors]);

  //End of new code

  const handleEstTravelTimeChange = () => setEstTravelTime(!estTravelTime);

  const handleBillingFreqChange = (value) => setBillingFreq(value);
  const handleRecurringTypeChange = (value) => setRecurringType(value);

  const handledDepositReqChange = () => setDepositReq(!depositReq);
  const handleDepositTypeChange = (value) => setDepositType(value);

  const handleFormatBilling = (event, newFormats) => {
    setFormatsBilling(newFormats);
  };

  const handleOpenScheduleAstDlg = () => setOpenScheduleAst(true);
  const handleCloseScheduleAstDlg = () => setOpenScheduleAst(false);

  // const handleOpenServiceDlg = () => setOpenServiceDlg(true);
  // const handleCloseServiceDlg = () => setOpenServiceDlg(false);

  const handleOpenUploadDlg = () => {
    setOpenUploadDlg(true);
  };

  //#endregion states

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleNavigation = (to) => {   
     
      
    if(isChanged){
       handleOpenUnsavedChangesDlg('navigate');
      // MySwal.fire({
      //   title: "Are you sure?",
      //   html: "This page has unsaved changes",
      
      //   showCancelButton: true,
      //   confirmButtonColor: "#23A26D",
      //   cancelButtonColor: "#d33",
      //   confirmButtonText: "Discard Changes",
      //   cancelButtonText: "Cancel",
      //   allowEscapeKey: true,
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     navigate(-1);
      //     setHasUnsavedChanges(false);
      //   }
      // });
    }else{
      navigate(to);
    }
  };

  useEffect(() => {
      const handleBeforeUnload = (e) => {
        if (hasUnsavedChanges) {
          e.preventDefault();
          e.returnValue = '';
        }
      };
    
       const handleBackButton = (event) => {
      if (hasUnsavedChanges) {
        event.preventDefault();
         handleOpenUnsavedChangesDlg('navigate');

        
          // MySwal.fire({
          //   title: "Are you sure?",
          //   html: "This page has unsaved changes",
          //   showCancelButton: true,
          //   confirmButtonColor: "#23A26D",
          //   cancelButtonColor: "#d33",
          //   confirmButtonText: "Discard Changes",
          //   cancelButtonText: "Cancel",
          //   allowEscapeKey: true,
          // }).then((result) => {
          //   if (result.isConfirmed) {
          //     navigate(-1);
          //     setHasUnsavedChanges(false);
          //   }
          // });
        }else{
          navigate('/estimates');
        }
      };
    
      window.history.pushState(null, '', window.location.href);
    
      window.addEventListener('beforeunload', handleBeforeUnload);
      window.addEventListener('popstate', handleBackButton);
    
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
        window.removeEventListener('popstate', handleBackButton);
      };
    }, [hasUnsavedChanges]);

  const handlePageBack = () => {
    handleNavigation("/estimates");
  };

  useEffect(() => {
    if (serviceRequest?.status) {
      const convertedStatuses = [
        'Assessment',
        'Estimate', 
        'Work Order',
        'Converted to Assessment',
        'Converted to Estimate',
        'Converted to Work Order'
      ];
      
      if (convertedStatuses.includes(serviceRequest.status)) {
        setConversionBannerVisible(true);
      }
      if (linkedFromEntityId) {
        console.log('Request is linked from entity:', linkedFromEntityId);
      }
    }
  }, [serviceRequest?.status, linkedFromEntityId]);

  const getEntityInfo = (status, entityId) => {
    let entityType = '';
    let prefix = '';
    let route = '';
    
    switch(status) {
      case 'Assessment':
      case 'Converted to Assessment':
        entityType = 'Assessment';
        prefix = 'AST';
        route = `/assessments/detail/${entityId}`;
        break;
      case 'Estimate':
      case 'Converted to Estimate':
        entityType = 'Estimate';
        prefix = 'EST';
        route = `/estimates/detail/${entityId}`;
        break;
      case 'Work Order':
      case 'Converted to Work Order':
        entityType = 'WorkOrder';
        prefix = 'WO';
        route = `/work-orders/detail/${entityId}`;
        break;
      case 'Request':
      default:
        entityType = 'Request';
        prefix = 'REQ';
        route = `/requests/detail/${entityId}`;
        break;
    }
    
    return { entityType, prefix, route };
  };

  return (
    <UserLayout
      contentHeightFixed={contentHeightFixed}
      activeLink={"Estimates"}
      showIcon={true}
      NavURL={handlePageBack}
    >
      <Card sx={{ width: "100%", height: "100%", position: "relative" }}>
      <CardHeader
      title={
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            gap: { xs: 2, md: 0 },
            width: '100%',
            minHeight: '64px' // Prevent height changes during load
          }}
        >
          {/* Left Side - Stacked in mobile */}
          <Box sx={{ 
            display: "flex", 
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "center" },
            gap: { xs: 1, md: 2 },
            width: { xs: "100%", md: "auto" },
            flexWrap: 'wrap',
            minHeight: '40px'
          }}>
            <Typography variant="h3" sx={{ fontWeight: "bold", flexShrink: 0 }}>
              EST-{serviceRequest?.requestID}
            </Typography>
            <HtmlTooltip
              title={
                <Box sx={{ p: (4, 2) }}>
                  <Box sx={{ mb: 6 }}>
                    <Typography
                      color="text.primary"
                      fontSize="small"
                      fontWeight="600"
                      mb={2}
                    >
                      Customer Details
                    </Typography>
                    <Box sx={{ display: "flex", gap: 20 }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        {customer?.customerType === 'Business' ? (
                          <Typography color="text.secondary" fontSize="small">
                            Company Name
                          </Typography>
                        ) : (
                          <Typography color="text.secondary" fontSize="small">
                            Customer Name
                          </Typography>
                        )}
                        <Typography color="text.secondary" fontSize="small">
                          Email
                        </Typography>
                        <Typography color="text.secondary" fontSize="small">
                          Phone
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        {customer?.customerType === 'Business' ? (
                          <Typography fontSize="small">
                            {customer?.companyName}
                          </Typography>
                        ) : (
                          <Typography fontSize="small">
                            {serviceRequest?.customerName}
                          </Typography>
                        )}
                        <Typography fontSize="small">
                          {customer?.email}
                        </Typography>
                        <Typography fontSize="small">
                          {customer?.phoneNumbers[0]?.phoneNo}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              }
            >
              <Box sx={{ flexShrink: 0 }}>
                <CustomChip
                  sx={{ cursor: "pointer" }}
                  label={
                    <Typography variant="body1" color="primary" sx={{ maxWidth: '200px', overflow: 'hidden' }}>
                      {serviceRequest?.requestTitle}
                    </Typography>
                  }
                  color="secondary"
                  skin={theme.palette.mode === "dark" ? 'dark' : 'light'}
                  icon={<Icon icon="tabler:building" />}
                />
              </Box>
            </HtmlTooltip>
            {/* <CustomChip label="Internal" color="info" skin="light" sx={{ flexShrink: 0 }} /> */}
           <CustomChipWithDropdown
            tag={serviceRequest?.status}
            onSelect={(selectedTag) => {
              handleStatusChange('status', selectedTag);
            }}
          />
            <AvatarGroup
              className="pull-up"
              max={4}
              sx={{
                "& .MuiAvatar-root": { width: 25, height: 25 },
                "& .MuiAvatarGroup-avatar": { width: 25, height: 25 },
                flexShrink: 0
              }}
            >
              {filteredEmployees && filteredEmployees
                .filter(employee => assignedUserIds.includes(employee.employeeID))
                .map((employee, index) => {
                  const employeeFullName = `${employee.firstName} ${employee.lastName}`;
                  return (
                    <Tooltip key={employee.employeeID} title={employeeFullName}>
                      <Avatar
                        src={employee.avatarUrl || `/images/avatars/${index + 1}.png`}
                        alt={employeeFullName}
                        sx={{ width: 25, height: 25 }}
                      />
                    </Tooltip>
                  );
                })}
            </AvatarGroup>
          </Box>
          
          {/* Right Side - Buttons */}
          <Box sx={{ 
            display: "flex", 
            gap: 2,
            width: { xs: "100%", md: "auto" },
            justifyContent: { xs: "flex-start", md: "flex-end" },
            minWidth: { md: '320px' }, // Fixed width to prevent layout shifts
            flexShrink: 0,
            mt: { xs: 1, md: 0 }
          }}>
            <Button 
              variant="contained" 
              color="main" 
              disabled={btnLoading || !isChanged} 
              onClick={handleSaveServiceRequest}
              sx={{ 
                minWidth: '140px',
                height: '40px',
                flexShrink: 0
              }}
            >
              {btnLoading ? <CircularProgress size={24} /> : 'Save Changes'}
            </Button>
            <Box sx={{ flexShrink: 0 }}>
              <ConversionComponent
                handleOpenSchedule={handleOpenScheduleAstDlg}
                schedulingReq={schedulingReq}
                setSchedulingReq={setSchedulingReq} 
                originalRequestID={requestID}
                openScheduleAst={openScheduleAst}
                handleCloseScheduleAstDlg={handleCloseScheduleAstDlg}
                setLoading={setLoading}
                module="Estimate"
                rules={rules}
                hasConvertToPermission={true}
              />
            </Box>
            <Box sx={{ 
                flexShrink: 0,
                transform: 'translateZ(0)' 
              }}>
                <MainOptions 
                rules={rules} 
                sendEstimate={sendEstimate}
                />
              </Box>
          </Box>
        </Box>
      }
/>
       {conversionBannerVisible && serviceRequest?.status && (
     <Box
       sx={{
         backgroundColor: theme.palette.mode === 'dark' ? 'rgba(251,188,4,0.15)' : 'rgb(255, 224, 100)',
         border: `1px solid ${theme.palette.mode === 'dark' ? '#b38f00' : 'rgb(255, 224, 100)'}`,
         borderRadius: 1,
         padding: 4,
         margin: 1,
         display: 'flex',
         alignItems: 'center',
         gap: 3,
       }}
     >
       <Icon icon="tabler:info-circle" color={theme.palette.mode === 'dark' ? 'rgb(255, 224, 100)' : theme.palette.primary.main} />
       <Typography
        variant="h6"
        sx={{ color: theme.palette.mode === 'dark' ? theme.palette.warning.light : theme.palette.primary.main }}
      >
        This has been converted into {serviceRequest.status === 'Work Order' ? 'a' : 'an'} <strong>{serviceRequest.status}</strong>, and you can no longer make changes.
        {linkedFromEntityId && (
          <span>
            {' '}Click here to view{' '}
            <Link
              to={getEntityInfo(serviceRequest.status, linkedFromEntityId).route}
              style={{
                color: theme.palette.mode === 'dark' ? theme.palette.warning.light : theme.palette.primary.main,
                textDecoration: 'underline',
                fontWeight: 600,
                cursor: 'pointer',
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigate(getEntityInfo(serviceRequest.status, linkedFromEntityId).route);
              }}
            >
              {getEntityInfo(serviceRequest.status, linkedFromEntityId).prefix}-{linkedFromEntityId}
            </Link>
          </span>
        )}
      </Typography>
     </Box>
   )}
        <CardContent>
          <Box>
            <TabContext value={value}>
              <TabList
                sx={{ mb: 2 }}
                onChange={handleTabChange}
                scrollButtons="auto"
                variant="scrollable"
                aria-label="simple tabs example"
              >
                <Tab
                  value="1"
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        width: "100%",
                        color: theme.palette.mode === 'dark' ? 
                          value === "1" ? "#fff" : "inherit" :
                          "inherit"
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: { xs: '0.875rem', md: "1rem" },
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Estimate Details
                      </Box>
                    </Box>
                  }
                />
                <Tab
                  value="2"
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        width: "100%",
                        color: theme.palette.mode === 'dark' ? 
                          value === "2" ? "#fff" : "inherit" :
                          "inherit"
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: { xs: '0.875rem', md: "1rem" },
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Work Requirements
                      </Box>
                    </Box>
                  }
                />
                <Tab
                  value="3"
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        width: "100%",
                        color: theme.palette.mode === 'dark' ? 
                          value === "3" ? "#fff" : "inherit" :
                          "inherit"
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: { xs: '0.875rem', md: "1rem" },
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Attachments
                      </Box>
                    </Box>
                  }
                />
                <Tab
                  value="4"
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        width: "100%",
                        color: theme.palette.mode === 'dark' ? 
                          value === "4" ? "#fff" : "inherit" :
                          "inherit"
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: { xs: '0.875rem', md: "1rem" },
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Notes
                      </Box>
                    </Box>
                  }
                />
                <Tab
                  value="5"
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        width: "100%",
                        color: theme.palette.mode === 'dark' ? 
                          value === "5" ? "#fff" : "inherit" :
                          "inherit"
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: { xs: '0.875rem', md: "1rem" },
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Linked Records
                      </Box>
                    </Box>
                  }
                />
                <Tab
                  value="6"
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        width: "100%",
                        color: theme.palette.mode === 'dark' ? 
                          value === "6" ? "#fff" : "inherit" :
                          "inherit"
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: { xs: '0.875rem', md: "1rem" },
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Assignees
                      </Box>
                    </Box>
                  }
                />
                <Tab
                  value="7"
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        width: "100%",
                        color: theme.palette.mode === 'dark' ? 
                          value === "7" ? "#fff" : "inherit" :
                          "inherit"
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: { xs: '0.875rem', md: "1rem" },
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Terms & Conditions
                      </Box>
                    </Box>
                  }
                />
              </TabList>
              <TabPanel value="1" sx={{ px : 0 }}>
                  <Box
                    sx={{ 
                      display: 'flex', 
                      gap: { md: 8, xs: 0 }, 
                      flexDirection: { md: 'row', xs: 'column' } 
                    }}
                  >
                    {/* Left Column */}
                    <Box sx={{ 
                      width: { md: '30%', xs: '100%' }, 
                      maxWidth: { md: '30%', xs: '100%' } 
                    }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12}>
                        <Divider
                          sx={{
                            color: "text.disabled",
                            "& .MuiDivider-wrapper": { px: 6 },
                            fontSize: theme.typography.body2.fontSize,
                            my: (theme) => `${theme.spacing(3)} !important`,
                          }}
                        >
                          Basic Information
                        </Divider>
                      </Grid>
                      <Grid item xs={12}>
                        <CustomTextField
                          fullWidth
                          label="Estimate Title"
                          required 
                          disabled={!rules.canEdit}                       
                          placeholder="Enter a brief estimate title"
                          error={!!requestErrors.requestTitle}
                          helperText={requestErrors.requestTitle}
                          onChange={(e) => { setServiceRequest((prevState) => ({
                            ...prevState,
                            requestTitle: e.target.value,
                          })); }}
                          value={serviceRequest?.requestTitle}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <CustomTextField
                          fullWidth
                          label="Description"
                          multiline
                          rows={2}
                          disabled={!rules.canEdit}
                          placeholder="Add a description..."
                          onChange={(e) => { setServiceRequest((prevState) => ({
                            ...prevState,
                            reqDescription: e.target.value,
                          })); }}
                          value={serviceRequest?.reqDescription}
                        />
                      </Grid>
                      <Grid item xs={12} md={10}>
                        <Box
                          sx={{
                            border: "1px solid #DBDBDB",
                            borderRadius: 1,
                            p: 2,
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="success"
                                checked={serviceRequest?.isDeposit || false}
                                disabled={!rules.canEdit}  
                                onChange={(e) => handleServiceRequestChange('isDeposit', e.target.checked)}
                              />
                            }
                            label={
                              <>
                                <Typography variant="body1" color="text.primary">
                                  Deposit Required
                                </Typography>
                                <Typography variant="caption">
                                  Check this if a deposit is required
                                </Typography>
                              </>
                            }
                          />
                        </Box>
                      </Grid>
                      {serviceRequest?.isDeposit && (
                        <Grid item xs={12} md={10} lg={6}>
                          <CustomTextField
                            fullWidth
                            required
                            label='Deposit Amount'
                            placeholder='Enter deposit amount'
                            disabled={!rules.canEdit}  
                            value={formatCurrencyDisplay(serviceRequest?.depositAmount)}
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(/[^0-9.]/g, '');
                              handleServiceRequestChange('depositAmount', numericValue);
                            }}
                            InputProps={{
                              startAdornment: (<InputAdornment position='start'>$</InputAdornment>),
                            }}
                            error={!!requestErrors.depositAmount}
                            helperText={requestErrors.depositAmount}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <Divider
                          sx={{
                            color: "text.disabled",
                            "& .MuiDivider-wrapper": { px: 6 },
                            fontSize: theme.typography.body2.fontSize,
                            my: (theme) => `${theme.spacing(3)} !important`,
                          }}
                        >
                          General Information
                        </Divider>
                      </Grid>
                      <Grid item xs={12}>
                        <FormLabel sx={{ fontSize: "13px", color: "text.primary", mb: '4px' }}>
                          Customer Name <span style={{ color: theme.palette.error.main }}>*</span>
                        </FormLabel>
                        <Box sx={{
                          border: `1px solid rgba(47, 43, 61, 0.2)`,
                          p: 2,
                          borderRadius: 1,
                          cursor: 'default',
                          backgroundColor: 'action.disabledBackground'
                        }}>
                          <Typography variant="body1">
                            {customer?.customerType === 'Individual' ?
                              `${customer?.firstName} ${customer?.lastName}` :
                              customer?.customerType === 'Business' ?
                                customer?.companyName :
                                'N/A'}
                          </Typography>
                        </Box>
                      </Grid>
                       <Grid item xs={12}>
                          <CustomAutocomplete
                            fullWidth
                            required
                            disabled={!customer?.customerID}
                            options={[
                              { jobsiteID: "create-new", jobsiteName: "+ Create New Jobsite", isCreateOption: true },
                              ...((allJobsites || [])
                                .filter(option => option.jobsiteName)
                                .sort((a, b) => a.jobsiteName.localeCompare(b.jobsiteName)))
                            ]}
                            getOptionLabel={(option) => option.jobsiteName || ""}
                            value={
                              allJobsites?.find(
                                (jobsite) => jobsite.jobsiteID === serviceRequest?.jobSiteID
                              ) || null
                            }
                            onChange={(event, newValue) => {
                              if (newValue?.isCreateOption) {
                                if (customer?.customerID) {
                                  handleOpenNewJobsiteDlg();
                                }
                              } else if (newValue) {
                                handleJobsiteDropdownChange(newValue.jobsiteID);
                              }
                            }}
                            isOptionEqualToValue={(option, value) =>
                              option.jobsiteID === value.jobsiteID
                            }
                            filterOptions={(options, params) => {
                              const filtered = options
                                .filter((option) => {
                                  if (option.isCreateOption) return true;
                                  const jobsiteName = option.jobsiteName || "";
                                  return jobsiteName.toLowerCase().includes(params.inputValue.toLowerCase());
                                })
                                .filter(option => option.isCreateOption || option.jobsiteName);
                              return filtered;
                            }}
                            renderOption={(props, option) => (
                              <li {...props}>
                                <span style={{ 
                                  fontWeight: option.isCreateOption ? 'bold' : 'normal',
                                  color: option.isCreateOption && !customer?.customerID ? 'rgba(0, 0, 0, 0.38)' : 'inherit',
                                }}>
                                  {option.jobsiteName}
                                </span>
                              </li>
                            )}
                            renderInput={(params) => (
                              <CustomTextField
                                {...params}
                                label="Jobsite"
                                required
                                placeholder="Select Jobsite"
                                error={!!requestErrors.jobSiteID}
                                helperText={requestErrors.jobSiteID}
                              />
                            )}
                          />
                        </Grid>
                     <Grid item xs={12}>
                        <CustomAutocomplete
                          fullWidth
                          required
                          disabled={!rules.canEdit}
                          id="jobsite-contact-autocomplete"
                          options={[
                            { id: "create-new", contact: "+ Create New Contact", isCreateOption: true },
                            ...((contacts || []).sort((a, b) => (a.contact || "").localeCompare(b.contact || "")))
                          ]}
                          getOptionLabel={(option) => option.contact || ""}
                          value={
                            contacts?.find(
                              (contact) => contact.id === serviceRequest?.jobsiteContactID
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue?.isCreateOption) {
                              handleOpenNewContactDlg();
                            } else if (newValue) {
                              handleContactDropdownChange(newValue.id);
                            }
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                          }
                          filterOptions={(options, params) => {
                            return options.filter((option) => {
                              if (option.isCreateOption) return true;
                              return (option.contact || "").toLowerCase().includes(params.inputValue.toLowerCase());
                            });
                          }}
                          renderOption={(props, option) => (
                            <li {...props}>
                              <span style={{ 
                                fontWeight: option.isCreateOption ? 'bold' : 'normal',
                              }}>
                                {option.contact}
                              </span>
                            </li>
                          )}
                          renderInput={(params) => (
                            <CustomTextField
                              {...params}
                              label="Jobsite Contact"
                              required
                              placeholder="Select Jobsite Contact"
                              error={!!requestErrors.jobsiteContactID}
                              helperText={requestErrors.jobsiteContactID}
                            />
                          )}
                        />
                      </Grid>  
                    </Grid>
                  </Box>
                  <Divider orientation='vertical' flexItem />
                  <Box sx={{ 
                       width: { md: '70%', xs: '100%' }, 
                       maxWidth: { md: '70%', xs: '100%' },
                       mt: { xs: 0, md: 0 }
                     }}>
                    <Grid container spacing={5}>
                    <Grid item xs={12} sm={12}>
                        <Divider
                          sx={{
                            color: "text.disabled",
                            "& .MuiDivider-wrapper": { px: 6 },
                            fontSize: theme.typography.body2.fontSize,
                            my: (theme) => `${theme.spacing(3)} !important`,
                          }}
                        >
                          Availability Details
                        </Divider>
                      </Grid>                    
                      <Grid item xs={12}>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <FormLabel sx={{ fontSize: "13px", color: "text.primary" }}>
                            Preferred Times
                          </FormLabel>
                          <FormControl component="fieldset">
                            {allTimes.map((time, index) => {

                              // Check if "Anytime" is checked
                              const isAnytimeChecked = serviceRequest?.availabilityTime.includes('1');

                              // Determine if the current time should be checked
                              const isChecked = isAnytimeChecked ||
                                serviceRequest?.availabilityTime.includes(
                                  Number(Object.keys(timeMapping).find((key) => timeMapping[key] === time))
                                );
                              return (
                                <FormControlLabel
                                  key={index}
                                  control={
                                    <Checkbox
                                    disabled={!rules.canEdit}
                                      checked={
                                        isChecked
                                      }
                                      onChange={(e) => handleTimeChange(time, e.target.checked)}
                                      color="success"
                                    />
                                  }
                                  label={time}
                                />
                              )
                            })}
                          </FormControl>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <FormLabel
                            sx={{
                              fontSize: "13px",
                              color: "text.primary",
                              marginBottom: "4px",
                            }}
                          >
                            Preferred Days
                          </FormLabel>
                          <ToggleButtonGroup value={availabilityDaysArray}>
                            {allDays.map((day, index) => {
                              const dayNumber = dayToNumberMap[day];
                              return (
                                <ToggleButton
                                  // disabled={!rules?.canEdit || dayNumber === 0 || dayNumber === 6}
                                  key={index}
                                  value={day}
                                  color={'info'}
                                  selected={availabilityDaysArray.includes(dayNumber)} // Mark selected ones
                                  onChange={() => handleDayChange(day)}
                                  sx={{
                              fontSize: { xs: "11px", sm: "13px" },
                              px: { xs: 1, sm: 2 },
                              minWidth: { xs: "40px", sm: "60px" },
                            }}
                                >
                                  {day}
                                </ToggleButton>
                              );
                            })}
                          </ToggleButtonGroup>                        
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormLabel
                          sx={{
                            fontWeight: 400,
                            fontSize: "13px",
                            marginBottom: "4px",
                            color: "text.primary",
                            height: "100%",
                          }}
                        >
                          Complete Work By
                        </FormLabel>
                        {loading ? (
                          <p></p> // Show a loading indicator while data is being fetched
                        ) : (
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              disabled={!rules.canEdit}
                              sx={{ width: '100%' }}
                              value={serviceRequest?.completeWorkBy && serviceRequest?.completeWorkBy !== "0001-01-01T00:00:00" && serviceRequest?.completeWorkBy !== "1900-01-01T00:00:00" ? dayjs(serviceRequest.completeWorkBy) : null}
                              onChange={(newValue) => {
                                handleCompleteWorkByDateChange(newValue);
                              }}
                              slotProps={{ textField: { size: 'small' } }}
                            />
                          </LocalizationProvider>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <Divider
                          sx={{
                            color: "text.disabled",
                            "& .MuiDivider-wrapper": { px: 6 },
                            fontSize: theme.typography.body2.fontSize,
                            my: (theme) => `${theme.spacing(6)} !important`,
                          }}
                        >
                          Additional Details
                        </Divider>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                          <Typography variant="body1" sx={{ mt: 2, mr: 6, mb: 4 }}>
                            Tags
                          </Typography>
                          <IconButton onClick={() => { handleOpenTagManagementDlg() }}
                          //  disabled={!rules.canEdit} 
                          sx={{ mb: 4 }}>
                            <AddIcon />
                          </IconButton>
                          {serviceRequest?.tags && serviceRequest.tags.length > 0 ? serviceRequest.tags.map((tag) => (
                            <CustomChip
                              label={tag.tagName}
                              skin='light'
                              // disabled={!rules.canEdit}
                              color='info'
                              deleteIcon={<Tooltip title='Click to remove tag'><CloseIcon /></Tooltip>}
                              onDelete={() => handleDeleteTag(tag.tagName)}
                              sx={{
                                cursor: 'pointer',
                                mr: 2,
                                mb: 2,
                                mt: 2,
                              }}
                            />
                          ))
                            :
                            (
                              <Typography variant="body2" sx={{ ml: 2, mt: 2, }}>
                                No tags
                              </Typography>
                            )
                          }
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                          <Button sx={{ position: 'absolute', bottom: 20, right: 20 }} variant="contained" color="main" disabled={btnLoading || !isChanged} onClick={handleSaveServiceRequest} >
                            {btnLoading ? <CircularProgress size={24} /> : 'Save Changes'}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </TabPanel>
              <TabPanel value="2" sx={{ px: 0}}>
                <Grid container spacing={5}>
                  {(workRequirementList && workRequirementList.length === 0) ? (
                    <>
                      <Grid item xs={12} md={6}>
                        <Card>
                          <CardContent
                            sx={{
                              display: "flex",
                              textAlign: "center",
                              alignItems: "center",
                              flexDirection: "column",
                              backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : "#FBFBFC",
                              p: (theme) =>
                                `${theme.spacing(9.75, 5, 9.25)} !important`,
                            }}
                          >
                            <CustomAvatar skin="light" color="info" sx={{ mb: 2.25 }}>
                              <Icon icon='tabler:building' />
                            </CustomAvatar>
                            <Typography variant="h5" sx={{ mb: 2.75 }}>
                              No Bundles added yet
                            </Typography>
                            <Typography sx={{ mb: 6, color: "text.secondary" }}>
                            Add bundles that are required by clicking on
                            “Add Bundle” button
                            </Typography>
                            <Button
                              variant="outlined"
                              color={theme.palette.mode === 'dark' ? "secondary" : "primary"}
                              startIcon={<AddIcon color="info" />}
                              onClick={handleOpenBundleDlg}
                              disabled={!rules.canEdit}
                            >
                              Add Bundle
                            </Button>
                          </CardContent>
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Card>
                          <CardContent
                            sx={{
                              display: "flex",
                              textAlign: "center",
                              alignItems: "center",
                              flexDirection: "column",
                              backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : "#FBFBFC",
                              p: (theme) =>
                                `${theme.spacing(9.75, 5, 9.25)} !important`,
                            }}
                          >
                            <CustomAvatar skin="light" color="info" sx={{ mb: 2.25 }}>
                              <Icon icon='tabler:building' />
                            </CustomAvatar>
                            <Typography variant="h5" sx={{ mb: 2.75 }}>
                              No Services added yet
                            </Typography>
                            <Typography sx={{ mb: 6, color: "text.secondary" }}>
                            Add services that are required by clicking on
                            “Add Service” button
                            </Typography>
                            <Button
                              variant="outlined"
                              color={theme.palette.mode === 'dark' ? "secondary" : "primary"}
                              startIcon={<AddIcon color="info" />}
                              onClick={handleOpenServiceDlg}
                              disabled={!rules.canEdit}
                            >
                              Add Service
                            </Button>
                          </CardContent>
                        </Card>
                      </Grid>
                    </>
                  ) : (                    
                  <Grid item xs={12} maxWidth="100%">
                    <WorkRequirements entity="estimate-detail" {...WorkRequirementsProps} rules={rules} />
                  </Grid>              
                  )}
                </Grid>
              </TabPanel>
              <TabPanel value="3" sx={{ px: 0 }}>
                <AttachmentsComponent 
                  rules={rules}
                  request={serviceRequest}
                  requestType={"Estimate"}
                  handleOpenUnsavedChangesDlg={handleOpenUnsavedChangesDlg}
                  theme={theme}
                  loading={loading}
                  AttachmentProps={AttachmentProps}
                  openUploadDlg2={openUploadDlg2}
                  setOpenUploadDlg2={setOpenUploadDlg2}
                />
              </TabPanel>
              <TabPanel value="4" sx={{p: 0, pt: 4,}}>
                <Box sx={{
                  height: '70vh',
                }}>
                  <NotesComponent 
                    requestID={requestID}
                    requestType={"Estimate"}
                    customerID={serviceRequest?.customerID}
                    setLoading={setLoading}
                    rules={rules}                    
                  />
                </Box>
              </TabPanel>
              <TabPanel value="5" sx={{px: 0}}>
                <LinkedRecordsComponent 
                  requestID={requestID} 
                  customerID={serviceRequest?.customerID}
                  setLoading={setLoading}
                  module="detail"
                  rules={rules}
                />
              </TabPanel>
              <TabPanel value="6" sx={{px: 0}}>       
                <Grid container spacing={5}>
                <AssignToComponent 
                    requestID={requestID}
                    serviceRequest={serviceRequest}
                    requestType={"Estimate"}
                    setLoading={setLoading}
                    rules={rules}  
                    navigate= {navigate} 
                    handleServiceRequestChange={handleServiceRequestChange}                    
                  />
                </Grid>     
              </TabPanel>
              <TabPanel value="7" sx={{px: 0}}>
                <Card>
                  <CardHeader
                    title="Terms & Conditions"
                    sx={{
                      pb: 4,
                      '& .MuiCardHeader-title': {
                        fontSize: '1.25rem',
                        fontWeight: 600
                      }
                    }}
                  />
                  <CardContent>
                    <DataGridPro
                      autoHeight
                      getRowId={(row) => row.id}
                      rowSelection={false}
                      rows={termsAndConditions}
                      rowHeight={62}
                      // loading={loading}
                      columns={[
                        {
                          flex: 0.3,
                          minWidth: 250,
                          field: "description",
                          headerName: "Terms and Conditions",
                          renderCell: (params) => {
                            const { row } = params;
                            return (
                              <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                                <Typography noWrap variant="body1">
                                  {row.description}
                                </Typography>
                              </Box>
                            );
                          },
                        },
                        {
                          flex: 0.15,
                          minWidth: 120,
                          field: "moduleName",
                          headerName: "Module",
                          renderCell: (params) => {
                            const { row } = params;
                            return (
                              <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                                <Typography noWrap variant="body1">
                                  {row.moduleName}
                                </Typography>
                              </Box>
                            );
                          },
                        },
                        {
                          flex: 0.15,
                          minWidth: 120,
                          field: "createdOn",
                          headerName: "Created On",
                          renderCell: (params) => {
                            const { row } = params;
                            return (
                              <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                                <Typography noWrap variant="body1">
                                  {row.createdOn}
                                </Typography>
                              </Box>
                            );
                          },
                        },
                        {
                          flex: 0.15,
                          minWidth: 120,
                          field: "createdBy",
                          headerName: "Created By",
                          renderCell: (params) => {
                            const { row } = params;
                            return (
                              <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                                <Typography noWrap variant="body1">
                                  {row.createdBy}
                                </Typography>
                              </Box>
                            );
                          },
                        },
                        {
                          flex: 0.15,
                          minWidth: 140,
                          field: "lastUpdated",
                          headerName: "Last Updated",
                          renderCell: (params) => {
                            const { row } = params;
                            return (
                              <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                                <Typography noWrap variant="body1">
                                  {row.lastUpdated}
                                </Typography>
                              </Box>
                            );
                          },
                        },
                      ]}
                      sx={{
                        "& .MuiDataGrid-columnHeaderTitle": {
                          textTransform: "none",
                          fontWeight: 600
                        },
                      }}
                      hideFooter
                      localeText={{
                        noRowsLabel: "No Terms & Conditions found for Estimates. Manage them in Settings."
                      }}
                    />
                  </CardContent>
                </Card>
              </TabPanel>
            </TabContext>
          </Box>
        </CardContent>
      </Card>

      {/* Popup Dialogs */}

      <AddContactDialog
        open={openNewContactDlg}
        handleClose={handleCloseContactDialog}
        customer = {customer}
        setLoading={setLoading}
        fetchContactData = {fetchContacts}   
        toast = {toast}                 
        contacts = {allContacts}
      />

      <AddServiceDialog
        {...AddServiceProps}
      />
     
      <AddJobsiteDialog
             open={openNewJobsiteDlg}
             handleClose={handleCloseNewJobsiteDlg}
             setJobsiteOpen={setOpenNewJobsiteDlg}
             customer={customer}
             fetchContactData={fetchContacts}
             toast={toast}
             jobsite={jobsite}
             handleJobsiteChange={handleJobsiteChange}
             navigate={navigate}
             NProgress={NProgress}
             fetchContacts={fetchContacts}
             fetchJobsites={fetchJobsites}
             contacts={allContacts}
             propertyArea={propertyArea}
             setPropertyArea={setPropertyArea}
             areaMeasurement={areaMeasurement}
             setAreaMeasurement={setAreaMeasurement}
             setLoading={setLoading}
             activeStep={activeStepJobsite}
             setActiveStep={setActiveStepJobsite}
             clearAreaMeasurement={clearAreaMeasurement}
             fetchPropertyArea={fetchPropertyArea}
             propertyAreaList={propertyAreaList}
             clearPropertyArea={clearPropertyArea}
             jobsiteContent={jobsiteContent}
             alertList={alertList}
             setAlertList={setAlertList}
             files={files}
             setFiles={setFiles}
           />
      <AddBundleDialog
        {...AddBundleProps}
      />
     <UnsavedChangesDialog open={openUnsavedChangesDlg} handleClose={handleCloseUnsavedChangesDlg} handleDiscard={handleDiscardChanges} />
      <PreAttachment
        Title="Upload Attachment"
        {...AttachmentProps}
      />

      <TagManagementDialog
        open = {openTagManagementDlg}
        handleClose = {handleCloseTagManagementDlg}      
        data = {{title:'Tag Management'}}
        handleAddTag = {handleAddTag}
        handleDeleteTag = {handleDeleteTag}
        tags = {serviceRequest?.tags}
        tag = {Tag}
        setTag = {setTag}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 10000 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </UserLayout>
  );
};

export default EstimateDetail;
